import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as mediaService from '../services/mediaService';

// Async thunks
export const fetchAudioLogListThunk = createAsyncThunk(
  'media/fetchAudioLogList',
  async (_, { rejectWithValue }) => {
    try {
      return await mediaService.fetchAudioLogs();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const fetchVideoLogListThunk = createAsyncThunk(
  'media/fetchVideoLogList',
  async (_, { rejectWithValue }) => {
    try {
      return await mediaService.fetchVideoLogs();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);




const mediaSlice = createSlice({
  name: 'media',
  initialState: {
    data:[],
    status: 'idle',
    uniqueCode: "",
    error: null,
    submitted: false, // to track if the form was submitted
  },
  reducers: {
    clearError(state) {
      state.error = null;
    },
    resetSubmission(state) {
      state.submitted = false;
      state.status = 'idle';
    },
     clearUniqueCode: (state) => {
      state.uniqueCode = null;
    },
  },
  extraReducers: builder => {
    builder
      // fetchUsers
      .addCase(fetchAudioLogListThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAudioLogListThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(fetchAudioLogListThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
            .addCase(fetchVideoLogListThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchVideoLogListThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(fetchVideoLogListThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })

  }
});

export const { clearError, resetSubmission,clearUniqueCode } = mediaSlice.actions;

export default mediaSlice.reducer;
